import NFCeConfig from "./config"
import List from "./"

export const paths = [
    {
        path: '/nfce/settings',
        component: NFCeConfig
    },
    {
        path: '/nfce/list',
        component: List
    }
]
export const NFCeRouters = {
    icon: "receipt",
    testId: '',
    path: "/nfce/settings",
    label: "NFC-e",
    tree: [
        {
            testId: '',
            icon: 'list',
            path: '/nfce/list',
            label: "Notas Emitidas"
        },
        {
            icon: "cog",
            testId: '',
            path: "/nfce/settings",
            label: "Configurações"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFCe/routers.js